import axios from 'axios'
import useSWR from 'swr'
import { useLocale } from 'hooks'

export const useReturn = (hashId: string): UseReturnResponse => {
  const { localiseUrl } = useLocale()

  const { data, error, mutate } = useSWR(
    hashId ? `/api/returns/${hashId}` : null,
    (url) =>
      axios(localiseUrl(url, { localeAsParam: true })).then((res) => res.data),
    {
      // Poll every 3s while the return exists but has no label yet
      refreshInterval: (latestData: any) =>
        latestData?.post_sale_return &&
        !latestData?.post_sale_return?.shipment_document
          ? 3000
          : 0
    }
  )

  return {
    data,
    error,
    loading: !data && !error,
    mutate
  }
}

interface UseReturnResponse {
  data: any
  error: any
  loading: boolean
  mutate: () => void
}
